import type { Job } from "../../../../../../api/types";

/**
 * Get all jobs in a group based on a groupBy field
 */
export function getGroupJobs(jobs: Job[], groupByField: keyof Job, groupValue: string): Job[] {
	return jobs.filter((j) => String(j[groupByField] ?? "") === groupValue);
}

/**
 * Check if all jobs have a specific boolean field value
 */
export function allJobsHaveFieldValue(jobs: Job[], fieldKey: keyof Job): boolean {
	return jobs.every((j) => j[fieldKey]);
}

/**
 * Check if some jobs have a truthy field value
 */
export function someJobsHaveFieldValue(jobs: Job[], fieldKey: keyof Job): boolean {
	return jobs.some((j) => j[fieldKey]);
}
